import { render, staticRenderFns } from "./BackendView.vue?vue&type=template&id=568392e8"
import script from "./BackendView.vue?vue&type=script&lang=js"
export * from "./BackendView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports